/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

export const TEST_TOOL_REFRESH_RATE = 3000; // time in milliseconds to check for the execution output
